// extracted by mini-css-extract-plugin
export default {"close":"close-module-close-iDTgC","small":"close-module-small-gm2M9","dark":"close-module-dark-fNIaN"};